var _rect, _path, _path2, _comment, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 45 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ED0000",
    width: 45,
    height: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 6,
    d: "M0,9 h 45 m -45,12 h 45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0050F0",
    d: "M0,0L25.98076,15L0,30z"
  })), _comment || (_comment = /*#__PURE__*/React.createElement("comment", null, "the star is in the center of gravity of the triangle, so the x-pos is irrational (tan(30 deg) * 15)")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(8.6602540378443864676372317075294,15) scale(5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cone"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "triangle",
    points: "0,0 0,1 .5,1",
    transform: "translate(0,-1) rotate(18)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#triangle",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cone",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cone",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cone",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cone",
    transform: "rotate(-144)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/pr.86f52f9a59e67e2a8452ed1865ae86b4.svg";
export { ForwardRef as ReactComponent };